<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :items-per-page="-1"
    item-key="id"
    hide-default-footer
    loading-text="Carregando..."
    class="font-resp-tabela table-full-screen"
    height="calc(100vh - 440px)"
  >
    <template v-slot:progress>
      <v-progress-linear
        indeterminate
        rounded
        color="red"
        height="3"
      ></v-progress-linear>
    </template>

    <template #item.dia_mes_inicial="{ item }">
      <span v-for="(dado, idx) in JSON.parse(item.dia_mes_inicial)" :key="idx">
        <p class="pa-0 ma-0">{{ dado }}</p>
      </span>
    </template>

    <template #item.dia_mes_final="{ item }">
      <span v-for="(dado, idx) in JSON.parse(item.dia_mes_final)" :key="idx">
        <p class="pa-0 ma-0">{{ dado }}</p>
      </span>
    </template>

    <template #item.media_periodo_sazonalidade="{ item }">
      {{ Helpers.formatarValorComCasas(item.media_periodo_sazonalidade, 2) }}
    </template>

    <template #item.media_crescimento="{ item }">
      {{ Helpers.formatarValorComCasas(item.media_crescimento, 2) }}
    </template>

    <template #item.tempo_medio_ressuprimento="{ item }">
      {{ Helpers.formatarValorComCasas(item.tempo_medio_ressuprimento, 2) }}
    </template>

    <template #item.porcentagem="{ item }">
      {{ Helpers.formatarValorComCasas(item.porcentagem, 2) + '%' }}
    </template>

    <template #item.created_at="{ item }">
      {{ item.created_at.slice(0, 19) }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    dessertsProps: {
      type: Array,
    }
  },
  data() {
    return {
      singleExpand: true,
      expanded: [],
      search: '',
      headers: [
        { text: 'Filial', value: 'filial' },
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Descrição', value: 'descricao_produto' },
        { text: 'Tempo Ressuprimento', value: 'tempo_medio_ressuprimento' },
        { text: 'Dia/Mês Inicial', value: 'dia_mes_inicial' },
        { text: 'Dia/Mês Final', value: 'dia_mes_final' },
        { text: 'Média Período', value: 'media_periodo_sazonalidade' },
        { text: 'Porcentagem', value: 'porcentagem' },
        { text: 'Média Crescimento', value: 'media_crescimento' },
        { text: 'Tipo Ajuste', value: 'tipo_ajute_formatado' },
        { text: 'Recorrência', value: 'recorrencia_formatada' },
        { text: 'Modificado Em', value: 'created_at' },
        { text: '', value: 'actions' },
      ],
      desserts: []
    }
  },

  watch: {
    dessertsProps(val) {
      this.desserts = val;
    }
  }
}
</script>

<style>

</style>
